(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart-with-price"] && !Shopify.designMode) return;
  try {
    class AddToCartWithPriceButton extends HTMLElement {
    connectedCallback() {
      const closestSection = this.closest('.shopify-section');
      if (!closestSection) return;
      closestSection.addEventListener('theme:variantUpdate', this.updatePrice);
    }

    disconnectedCallback() {
      const closestSection = this.closest('.shopify-section');
      if (!closestSection) return;
      closestSection.removeEventListener('theme:variantUpdate', this.updatePrice);
    }

    updatePrice = (event) => {
      const priceElement = this.querySelector('[ref="buttonPrice"]');
      if (!priceElement) return;

      // Get the new price from the variant
      if (event.detail && event.detail.resource && event.detail.resource.price) {
        const defaultFormat = '$' + '{' + '{amount}' + '}';
        const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : defaultFormat;
        const newPrice = Shopify.formatMoney(event.detail.resource.price, moneyFormat);
        priceElement.textContent = newPrice;
      }
    };
  }

  if (!customElements.get('add-to-cart-with-price-button')) {
    customElements.define('add-to-cart-with-price-button', AddToCartWithPriceButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-now-with-price"] && !Shopify.designMode) return;
  try {
    class BuyNowWithPriceButton extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('[ref="buyNowButton"]');
      if (!button) return;

      button.addEventListener('click', this.handleBuyNow.bind(this));

      // Listen for variant changes to update price
      const closestSection = this.closest('.shopify-section');
      if (!closestSection) return;
      closestSection.addEventListener('theme:variantUpdate', this.updatePrice);
    }

    disconnectedCallback() {
      const closestSection = this.closest('.shopify-section');
      if (!closestSection) return;
      closestSection.removeEventListener('theme:variantUpdate', this.updatePrice);
    }

    handleBuyNow(event) {
      event.preventDefault();
      
      const button = event.currentTarget;
      if (button.disabled) return;

      // Get the variant ID from the form
      const form = this.closest('form');
      const variantIdInput = form.querySelector('[name="id"]');
      const variantId = variantIdInput ? variantIdInput.value : null;

      if (!variantId) return;

      // Get quantity (default to 1)
      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = quantityInput ? quantityInput.value : 1;

      // Disable button and show loading state
      button.disabled = true;
      const originalText = button.innerHTML;
      button.innerHTML = '<span class="buy-now-with-price__content">Processing...</span>';

      // Create checkout URL with variant and quantity
      const checkoutUrl = `/cart/${variantId}:${quantity}?storefront=true`;

      // Redirect to checkout
      window.location.href = checkoutUrl;

      // Re-enable button after a delay (in case redirect fails)
      setTimeout(() => {
        button.disabled = false;
        button.innerHTML = originalText;
      }, 3000);
    }

    updatePrice = (event) => {
      const priceElement = this.querySelector('[ref="buttonPrice"]');
      if (!priceElement) return;

      // Get the new price from the variant
      if (event.detail && event.detail.resource && event.detail.resource.price) {
        const defaultFormat = '$' + '{' + '{amount}' + '}';
        const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : defaultFormat;
        const newPrice = Shopify.formatMoney(event.detail.resource.price, moneyFormat);
        priceElement.textContent = newPrice;
      }
    };
  }

  if (!customElements.get('buy-now-with-price-button')) {
    customElements.define('buy-now-with-price-button', BuyNowWithPriceButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["urgency-timer"] && !Shopify.designMode) return;
  try {
    class UrgencyTimer extends HTMLElement {
    constructor() {
      super();
      this.countdown = this.querySelector('.urgency-timer__countdown');
      this.hoursElement = this.countdown.querySelector('[data-hours]');
      this.minutesElement = this.countdown.querySelector('[data-minutes]');
      this.secondsElement = this.countdown.querySelector('[data-seconds]');
      this.totalHours = parseInt(this.countdown.dataset.hours) || 24;
      
      this.initTimer();
    }

    initTimer() {
      // Check if timer exists in localStorage
      let endTime = localStorage.getItem('urgency_timer_end');
      
      if (!endTime || new Date(parseInt(endTime)) < new Date()) {
        // Create new timer
        endTime = new Date().getTime() + (this.totalHours * 60 * 60 * 1000);
        localStorage.setItem('urgency_timer_end', endTime);
      }
      
      this.endTime = parseInt(endTime);
      this.updateTimer();
      this.interval = setInterval(() => this.updateTimer(), 1000);
    }

    updateTimer() {
      const now = new Date().getTime();
      const distance = this.endTime - now;

      if (distance < 0) {
        // Reset timer
        this.endTime = new Date().getTime() + (this.totalHours * 60 * 60 * 1000);
        localStorage.setItem('urgency_timer_end', this.endTime);
        return;
      }

      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.hoursElement.textContent = this.pad(hours);
      this.minutesElement.textContent = this.pad(minutes);
      this.secondsElement.textContent = this.pad(seconds);
    }

    pad(num) {
      return num.toString().padStart(2, '0');
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

  customElements.define('urgency-timer', UrgencyTimer);
  } catch(e) { console.error(e); }
})();

})();
